module.exports = "/fast-coin/img/coin/anim/shine_2/shine_2_014.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_2/shine_2_014.png
// module id = 2361
// module chunks = 5